"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInScreen = void 0;
const Flex_1 = __importStar(require("@targetx/mineral-ui/Flex"));
const Link_1 = __importDefault(require("@targetx/mineral-ui/Link"));
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const palette_1 = __importDefault(require("@targetx/mineral-ui/themes/generated/palette"));
const Image_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Image"));
const react_1 = __importDefault(require("react"));
const paths_1 = __importDefault(require("../../constants/paths"));
const theme_1 = __importDefault(require("../../theme"));
const FindOrgForm_1 = __importDefault(require("../components/FindOrgForm"));
const SignInScreen_copyText_1 = __importDefault(require("./SignInScreen.copyText"));
function SignInScreen({ csrfToken, errorMessageKey, redirectURL }) {
    return (react_1.default.createElement(Flex_1.default, { alignItems: "center", background: [
            palette_1.default.blue[100],
            'url(//static.targetx.com/images/tx-common-background-a.2ab82581.png) top left / cover no-repeat fixed'
        ], breakpoints: ['medium'], direction: "column", height: "100%", paddingTop: theme_1.default.space_stack_xl, paddingHorizontal: theme_1.default.space_inline_md, width: "100%" },
        react_1.default.createElement(Image_1.default, { src: "tx-common-logo.6a64d3f9.svg", alt: SignInScreen_copyText_1.default.logoDescription, height: "4em" }),
        react_1.default.createElement(Flex_1.FlexItem, { backgroundColor: palette_1.default.white, borderRadius: "16px", maxWidth: 480, height: "fit-content", padding: theme_1.default.space_stack_lg, marginTop: theme_1.default.space_stack_xl },
            react_1.default.createElement(FindOrgForm_1.default, { action: paths_1.default.postFindOrg, csrfToken: csrfToken, errorMessageKey: errorMessageKey, redirectURL: redirectURL }),
            react_1.default.createElement(Text_1.default, { align: "center", marginTop: theme_1.default.space_stack_md },
                SignInScreen_copyText_1.default.supportMessage,
                ' ',
                react_1.default.createElement(Link_1.default, { underline: true }, SignInScreen_copyText_1.default.supportLinkText))),
        react_1.default.createElement(Text_1.default, { align: "center", color: palette_1.default.white, marginTop: theme_1.default.space_stack_lg }, SignInScreen_copyText_1.default.copyrightMessage)));
}
exports.SignInScreen = SignInScreen;
SignInScreen.copyText = SignInScreen_copyText_1.default;
SignInScreen.ERROR_INVALID_SID = FindOrgForm_1.default.ERROR_INVALID_SID;
SignInScreen.ERROR_UNEXPECTED = FindOrgForm_1.default.ERROR_UNEXPECTED;
exports.default = SignInScreen;
